/* eslint-disable react/jsx-no-target-blank */
import { ReloadOutlined } from '@ant-design/icons';
import { Button, Checkbox } from '@sinohealth/butterfly-ui-components';
import React, { useEffect, useRef, useState } from 'react';
import { httpBuildQrConnectUrl, httpBuildworkQrCodeUrl } from '../../http';
// import $ from '../../utils/jquery-3.7.0.min.js';
import styles from './index.less';

const QRCODE = require('../../images/qrcode.png');

const TabsLis: any = [
  { label: '微信扫码', code: 'qrCode' },
  { label: '企微扫码', code: 'workQrCode' },
];

type ScanCodeProps = {
  /** 平台名称 */
  platformName?: string;
  serviceText?: string;
  serviceProtocolUrl?: string; // 服务协议
  privacyProtocolUrl?: string; // 隐私协议
  privacyText?: string;
  onAccount?: () => void;
  onMobile?: () => void;
};

/** 扫码登录 */
const ScanCode: React.FC<ScanCodeProps> = (props) => {
  const {
    platformName,
    serviceProtocolUrl,
    serviceText,
    privacyProtocolUrl,
    privacyText,
    onAccount,
    onMobile,
  } = props;

  const [qrcodeUrl, setQrcodeUrl] = useState('');
  const [currentTabs, setCurrentTabs] = useState('qrCode');
  const contentIFrameRef = useRef<HTMLIFrameElement>(null);
  const [agreeProtocol, setAgreeProtocol] = useState(false);
  const [expiration, setExpiration] = useState(false);

  const httpBuildQrConnectUrlReq = async () => {
    try {
      if (currentTabs === 'qrCode') {
        const res: any = await httpBuildQrConnectUrl(`${window.location.href}`);
        console.log(res);
        setQrcodeUrl(res);
      } else if (currentTabs === 'workQrCode') {
        const res: any = await httpBuildworkQrCodeUrl(`${window.location.href}`);
        console.log(res);
        setQrcodeUrl(res);
      }
      setExpiration(true);
      cutdownTime();
    } finally {
      console.log('1321');
    }
  };

  const cutdownTime = () => {
    const timer = setTimeout(() => {
      setQrcodeUrl('');
      clearTimeout(timer);
    }, 1000 * 60 * 5);
  };

  useEffect(() => {
    if (!agreeProtocol) return;
    httpBuildQrConnectUrlReq();
  }, [agreeProtocol, currentTabs]);

  return (
    <div className={styles['scan-code']}>
      <div className={styles['scan-title']}>
        {TabsLis.map((el: any) => (
          <span
            key={el.code}
            className={`${styles['sub-title']} ${
              currentTabs === el.code ? styles['sub-active'] : ''
            }`}
            onClick={() => setCurrentTabs(el.code)}
          >
            {el.label}
          </span>
        ))}
      </div>
      {/* <Tabs tabs={TabsLis} current={currentTabs} onChange={setCurrentTabs} /> */}
      {!qrcodeUrl || !agreeProtocol ? (
        <div className={styles.title}>
          {currentTabs === 'qrCode' ? '微信扫码登录' : '企业微信扫码登录'}
        </div>
      ) : null}
      <div
        className={`${styles['code-container']} ${qrcodeUrl ? '' : styles['code-error']}`}
        style={{ marginBottom: !qrcodeUrl || !agreeProtocol ? 50 : 17 }}
      >
        {!agreeProtocol ? (
          <div className={styles['error-tip']}>
            <div style={{ marginBottom: 12 }}>请先阅读并同意</div>
            <div>服务条款 和 隐私协议</div>
          </div>
        ) : null}
        {!qrcodeUrl && expiration && agreeProtocol ? (
          <div
            className={styles['error-tip']}
            style={{ cursor: 'pointer' }}
            onClick={() => httpBuildQrConnectUrlReq()}
          >
            <div style={{ marginBottom: 12 }}>二维码已过期</div>
            <div>
              请刷新
              <ReloadOutlined style={{ marginLeft: 8 }} />
            </div>
          </div>
        ) : null}
        {qrcodeUrl && agreeProtocol ? (
          // eslint-disable-next-line jsx-a11y/iframe-has-title
          <iframe
            id="qrCode"
            ref={contentIFrameRef}
            className={styles['qrcode-img']}
            height={400}
            src={qrcodeUrl}
            onLoad={() => {
              const iframe: any = document.getElementById('qrCode');
              const iframeWindow = iframe?.contentWindow;
              // console.log($);
            }}
          />
        ) : null}
        {!qrcodeUrl ? (
          <img src={QRCODE} style={{ width: 240, height: 240, margin: '0 auto' }} />
        ) : null}
      </div>
      <div style={{ marginBottom: 24 }}>
        <Checkbox
          className={`${styles['small-font']}`}
          checked={agreeProtocol}
          onChange={(e) => {
            setAgreeProtocol(e.target.checked);
            setQrcodeUrl('');
          }}
        >
          阅读并同意{platformName}
        </Checkbox>
        <a
          href={serviceProtocolUrl || ''}
          className={`${styles['small-font']} ${styles.protocol}`}
          target="_blank"
        >
          {serviceText || '服务协议'}
        </a>
        <span className={styles['small-font']}> 和 </span>
        <a
          className={`${styles['small-font']} ${styles.protocol}`}
          href={privacyProtocolUrl || ''}
          target="_blank"
        >
          {privacyText || '隐私协议'}
        </a>
      </div>
      <div className={styles['scan-footer']}>
        <div
          className={`${styles['footer-tip']} ${
            !qrcodeUrl || !agreeProtocol ? '' : styles['footer-padding']
          }`}
        >
          其他登录方式
        </div>
        <div className={styles.footer}>
          <Button
            size="large"
            style={{ marginRight: 16, color: 'rgba(0, 0, 0, 0.65)' }}
            block
            onClick={onAccount}
          >
            账号登录
          </Button>
          <Button size="large" style={{ color: 'rgba(0, 0, 0, 0.65)' }} block onClick={onMobile}>
            手机号登录
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ScanCode;
